import { render } from "./SalaryItemsPage.vue?vue&type=template&id=2b36482e&scoped=true"
import script from "./SalaryItemsPage.vue?vue&type=script&lang=js"
export * from "./SalaryItemsPage.vue?vue&type=script&lang=js"

import "./SalaryItemsPage.vue?vue&type=style&index=0&id=2b36482e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b36482e"]])

export default __exports__